<i18n src="./../../i18n/product_summary.json"></i18n>

<template>
    <div class="p-0 m-0">
        <div class="row mt-offer-product no-gutters mt-3 pb-3">
            <div class="col-lg-3 mt-product-main-image">
                <img class="lazy product-thumbnail" :data-src="item.thumbnail" :alt="item.thumbnailAlt">
            </div>
            <div class="col-lg-7 mt-product-main-details pt-4">
                <router-link :to="{name: 'product', params: {productName: cleanPath(item.url)}}">
                    <p class="font-weight-bold mt-c-blue-light mt-fs-x-large product-name" v-text="item.name"/>
                </router-link>
                <p class="mt-c-grey mt-fs-small pt-3" v-text="item.features.slice(0, 3).join(', ')"/>
                <div v-if="item.canBuy" class="row pt-2">
                    <div class="col-4">
                        <p v-if="item.name.toLowerCase().includes(exceptionWashbasin)" class="mt-quantity-title mb-2" v-text="$t('cart.numberOfItems')" />
                        <p v-else class="mt-quantity-title mb-2" v-text="$t('cart.numberOfCabins')" />
                        <div class="no-gutters mt-q-input">
                            <div class="number-input">
                                <button class="plus" v-on:click="changeProductQuantity(item.id, Number(item.quantity) + 1)">+</button>
                                <input name="quantity" type="number" v-model="item.quantity" v-on:change="changeProductQuantity(item.id, Number(item.quantity))"/>
                                <button v-on:click="changeProductQuantity(item.id, Number(item.quantity) - 1)">-</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-8">
                        <p class="mt-quantity-title mb-2" v-text="$t('cart.serviceFrequency')" />
                        <div class="no-gutters mt-select">
                            <select class="mt-form-control" :value="selectedService(item.id)" v-on:change="changeServiceType(item.id, $event)">
                                <option v-for="service in item.possibleVariations" :key="service.id" v-bind:value="service.id" v-text="service.serviceType"/>
                            </select>
                        </div>
                    </div>
                </div>
                <p v-if="item.canBuy" class="mt-quantity-title mb-2 pt-4">{{ $t('cart.price') }}
                    <span class="info-icon">i
                        <span class="tooltip mt-c-grey" v-text="$t('cart.priceTooltip')" />
                    </span>
                </p>
                <p v-if="item.canBuy" class="pt-3 font-weight-bold mt-fs-x-large">{{ productNetPrice(item.id) }} {{ currencyShort }} / {{ $t('cart.net') }}</p>
            </div>
            <div class="col-lg-1"/>
            <div class="col-lg-1 pt-2 text-center">
                <font-awesome-icon class="fa-mt-remove" icon="times" v-on:click="removeFromCart(item.id)"/>
            </div>
        </div>

        <div v-if="item.availableAdditionalServices && Array.isArray(item.availableAdditionalServices) && item.availableAdditionalServices.length > 0" class="row mt-offer-product no-gutters mt-3 pb-4">
            <div class="col-lg-12 mt-product-main-details p-4">
                <p class="font-weight-bold mt-fs-x-large pt-2" v-text="$t('cart.additionalServicesTitle')"/>
            </div>

            <div class="row vas-row ml-4 mr-4 p-3 m-1" v-for="service in item.availableAdditionalServices" :key="service.id">
                <div class="col-auto vas-checkbox">
                    <input class="form-check-input" type="checkbox" :name="service.id" :id="service.id" :class="service.selected ? 'active' : ''" v-on:click="toggleAdditionalService(item.id, item.variation, service.id)"/>
                </div>
                <div class="col">
                    <label class="form-check-label" :for="service.id" v-text="service.name"/>
                </div>
                <div v-if="service.serviceType === 'ONE_TIME_FEE' || service.serviceType === 'RECURRING_FEE'" class="col-auto align-content-end align-self-end ml-auto">
                    <span class="vas-price">{{ service.netPrice.toFixed(2) }} {{ currencyShort }}{{ service.serviceType === 'RECURRING_FEE' ? ' / ' + $t('cart.1WeekPrice') : "" }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VanillaToasts from 'vanillatoasts'
    import 'vanillatoasts/vanillatoasts.css'
    import {mapGetters} from "vuex";
    import {Const} from "@/main";

    export default {
        name: "ProductSummary",
        components: {},
        props: {
            item: {}
        },
        data () {
            return {
                currencyShort: Const.PRIMARY_CURRENCY_SHORT,
                exceptionWashbasin: Const.EXCEPTION_WASHBASIN,
                price: 0,
            }
        },
        computed: {
            ...mapGetters(['getCart']),
            selectedService() {
                return (id) => this.getCart.find(item => item.id === id).variation;
            },
            productNetPrice() {
                return (id) => {
                    let product = this.getCart.find(item => item.id === id);
                    let net = product.possibleVariations.find(variation => variation.id === Number(product.variation)).netPrice;
                    return (product.quantity * net).toFixed(2);
                }
            }
        },
        mounted() {
            if (this.item.availableAdditionalServices && Array.isArray(this.item.availableAdditionalServices) && this.item.availableAdditionalServices.length > 0) {
                this.item.availableAdditionalServices.sort((a, b) => a.serviceType.localeCompare(b.serviceType));
            }
        },
        methods: {
            removeFromCart(id) {
                this.$store.dispatch('removeFromCart', {
                    id: id
                });
                VanillaToasts.create({
                    title: this.$t('messages.productRemoved'),
                    type: 'success',
                    timeout: 3000,
                });
            },
            toggleAdditionalService(productId, variationId, additionalServiceId) {
                this.$store.dispatch('toggleAdditionalService', {
                    productId: productId,
                    variationId: variationId,
                    additionalServiceId: additionalServiceId
                })
            },
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            },
            updatePrice() {
                if (this.item.canBuy) {
                    this.price = this.getServicePriceById(this.item.selected.variation);
                }
            },
            changeProductQuantity(productId, quantity) {
                if (quantity < 1) {
                    return;
                }
                this.$store.dispatch('changeProductQuantity', {
                    productId: productId,
                    quantity: quantity
                });
            },
            changeServiceType(productId, event) {
                this.$store.dispatch('changeProductServiceType', {
                    productId: productId,
                    serviceType: event.target.value
                });
            },
        }
    }
</script>

<style scoped>
    .mt-quantity {
        font-size: 0.8rem;
        color: #999fa5;
    }

    .mt-cart-img {
        height: auto;
        width: 90px;
    }

    .fa-mt-remove {
        cursor: pointer;
        font-size: small;
        color: #a1a1a1;
        transition: color 100ms linear;
    }

    .fa-mt-remove:hover {
        color: #ce0000;
        transition: color 100ms linear;
    }

    .product-thumbnail {
        width: inherit;
    }

    .mt-additional-service {
      min-height: 30pt;
      background-color: #fff;
      padding-top: 0;
      border: 1px solid #e7e7e7;
    }

    .mt-additional-service:hover {
      border-color: #4092e5;
    }

    .mt-additional-service.active {
      border-color: #4092e5;
      border-width: 2px
    }

    .mt-additional-service-name {
      font-size: 10pt;
    }

    .mt-offer-product {
        background-color: #fff;
        padding-top: 1rem;
        border: 1px solid #e7e7e7
    }

    .mt-quantity-title {
        font-size: 16px;
    }

    .number-input {
        border: 1px solid #e2e2e2 !important;
        height: 50px !important;
    }

    .number-input button {
        font-weight: lighter !important;
        height: 50px !important;
        width: 20px !important;
        border-left: 1px solid #e2e2e2 !important;
    }

    .number-input input {
        outline: none !important;
        font-weight: lighter !important;
    }

    .number-input button.plus {
        border-left: 0 !important;
        border-right: 1px solid #e2e2e2 !important;
    }

    .number-input button:before {
        display: none !important;
    }

    .number-input button:after {
        display: none !important;
    }

    .number-input input {
        background-color: white !important;
        height: 49px !important;
        width: 50px !important;
    }

    .mt-select select {
        width: 200px;
        height: 40px;
        padding: 0 10px;
        border: 1px solid #e2e2e2;
        border-radius: 0px;
        appearance: none;
        background-color: white;
        background-image: url('data:image/svg+xml,<%3Fxml version="1.0" encoding="utf-8"%3F><!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --><svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" fill="%230F0F0F"/></svg>');
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        cursor: pointer;
        font-weight: lighter;
    }

    select:focus {
        border-color: #4092e5;
        outline: none;
    }

    .info-icon {
        position: relative;
        font-size: 10px;
        background-color: #f1f1f1;
        border-radius: 50%;
        border: 1px solid #e2e2e2;
        width: 15px;
        height: 15px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
        cursor: pointer;
    }

    .info-icon:hover .tooltip {
        opacity: 1;
        visibility: visible;
    }

    .tooltip {
        position: absolute;
        left: 25px;
        top: -5px;
        background-color: white;
        border: 1px solid #e2e2e2;
        border-radius: 0px;
        padding: 8px;
        width: 123px;
        font-size: 12px;
        line-height: 1.4;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, visibility 0.2s ease;
    }

    .product-name {
        line-height: 24px;
    }

    .vas-price {
        font-weight: bold;
        font-size: 16px;
    }

    .vas-row {
        width: 100%;
        border: 1px solid #e2e2e2;
    }

    .vas-checkbox {
        padding-left: 25px;
        padding-right: 0;
    }

    .vas-checkbox input {
        width: 15px;
        height: 15px;
        appearance: none;
        background-color: #fff;
        outline: 1px solid #6c6c6c;
        border-radius: 2px;
        position: relative;
    }

    .vas-checkbox input:checked {
        background: #4092e5;
        border: 2px solid #fff;
    }

</style>